<template>
  <div>
    <mainMenu
      :logado="true"
      :attEmpresas="this.attEmpresas"
      :conta="this.conta"
      :alert="this.alert"
      @emitAttEmpresas="emitAttEmpresas($event)"
      @getNewEmp="getNewEmp($event)"
      :firstAccess="this.firstAccess"
    ></mainMenu>
    <AlertComponent :alert="this.alert"></AlertComponent>
    <component
      @emitAttEmpresas="emitAttEmpresas($event)"
      :conta="this.conta"
      :alert="this.alert"
      v-bind:is="component.name"
      :empresa="empresa"
      :IBGE="this.IBGE"
      @getNewEmp="getNewEmp($event)"
      :firstAccess="this.firstAccess"
    ></component>
  </div>
</template>

<script>
import menu from "@/components/menu/Menu.vue";
import Vue from "vue";
import ConsultaNotas from "@/pages/loggedArea/consultaNotas/ConsultaNotas.vue";
import DashBoard from "@/pages/loggedArea/dashBoard/DashBoard.vue";
import editarPerfil from "@/pages/loggedArea/editarPerfil/EditarPerfil.vue";
import configuracoes from "@/pages/loggedArea/configuracoes/Configuracoes.vue";
import configuracoesAutomacao from "@/pages/loggedArea/configuracoes/configuracoesAutomacao/ConfiguracoesAutomacao.vue";
import Usuario from "@/domain/conta/usuario/Usuario.js";
import Conta from "@/domain/conta/Conta.js";
import ContaService from "@/domain/conta/ContaService.js";
import AlertComponent from "@/components/shared/alertMessage/AlertMessage.vue";
import AlertMessage from "@/domain/alertMessage/AlertMessage.js";
import EmpresasService from "@/domain/conta/empresa/EmpresaService.js";
import NotificacoesService from "@/domain/notificacoes/NotificacoesService.js";
import PrimeiroAcesso from "@/pages/loggedArea/firstAccess/FirstAccess.vue";
import Relatorio from "@/pages/loggedArea/relatorio/Relatorio.vue";
import FechamentoMes from "@/pages/loggedArea/fechamentoMes/FechamentoMes.vue";
import DocsFederal from '@/pages/loggedArea/docsFederal/DocsFederal';
import Loja from "@/pages/loggedArea/loja/Loja.vue";
import ValidaOcr from "@/pages/loggedArea/validaOcr/ValidaOcr.vue";
import { estados } from "@/domain/ibge/estados.js";
export default {
  components: {
    mainMenu: menu,
    ConsultaNotas: ConsultaNotas,
    DashBoard: DashBoard,
    editarPerfil: editarPerfil,
    configuracoes: configuracoes,
    AlertComponent: AlertComponent,
    PrimeiroAcesso: PrimeiroAcesso,
    Relatorio: Relatorio,
    FechamentoMes: FechamentoMes,
    Loja: Loja,
    configuracoesAutomacao,    
    ValidaOcr: ValidaOcr,   
  },
  data() {
    return {
      // vezes: 0,
      // oldId: '',
      empresa: [],
      error: undefined,
      alert: new AlertMessage(),
      component: { name: "" },
      route: this.$router.history.current.path,
      conta: new Conta(),
      notifiService: new NotificacoesService(this.$http),
      attEmpresas: false,
      IBGE: { estados: [], cidades: { att: false, uf: undefined, items: [] } },
      notificacoes: { data: null },
      firstAccess: { nfeQtd: 0, cteQtd: 0, nfseQtd: 0, buscando: true },
      tabs: [
        {
          title: "Recebidas"
        },
        {
          title: "Enviadas"
        }
      ]
    };
  },
  created: function() {
    if (this.$session.exists()) {
      let auxConta = this.$session.get("jwt");
      Vue.http.headers.common["Authorization"] =
        "Bearer " + auxConta.accessToken;
      Vue.http.headers.common["sessionId"] =
        this.$session.id();
      this.service = new ContaService(this.$http);
      this.conta.admin = auxConta.admin;
      this.conta.conta = auxConta.conta;
      this.conta.email = auxConta.email;
      auxConta.hasOwnProperty("emprs_not_admin")
      ? (this.conta["emprs_not_admin"] = auxConta.emprs_not_admin)
      : "";
      this.conta.favEmails = auxConta.favEmails;
      this.conta.gravatarProfile = auxConta.gravatarProfile;
      this.conta.id_usuario = auxConta.id_usuario;
      this.conta.nome = auxConta.nome;
      this.conta.colaborador = auxConta.colaborador;
      this.conta.primAcesso = auxConta.primAcesso;
      this.conta.imagem = auxConta.img;

      // this.conta["newFeatures"] = true;

      this.getEstados;
    } else {
      // debugger;
      this.error = {};
      this.error["show"] = true;
      this.error["msg"] = "Logue no sistema.";
      this.$router.afterHooks.push(this.error);
      this.$router.push("/login");
    }
  },
  mounted: function() {
    // this.openJivoChat();
    this.$nextTick(function() {
      if (!this.error) {
        if (this.conta.primAcesso) {
          this.$router.push("/primeiroAcesso");
        }
        if (
          this.$router.history.current.path == "/consultaCTe" ||
          this.$router.history.current.path == "/consultaNFe" ||
          this.$router.history.current.path == "/consultaNFSe"
        ) {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/ePerfil") {
          this.component.name = "editarPerfil";
        } else if (this.$router.history.current.path == "/verPerfil") {
          this.component.name = "verPerfil";
        } else if (this.$router.history.current.path == "/configuracoes") {
          this.component.name = "configuracoes";
        } else if (this.$router.history.current.path == "/configuracoesAutomacao") {
          this.component.name = "configuracoesAutomacao";
        } else if (this.$router.history.current.path == "/fornecedores") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/clientes") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/produtos") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/consultaIptu") {
          this.component.name = "ConsultaNotas";
        } else if (
          this.$router.history.current.path == "/relatorio" &&
          (this.$canAccessRelatorio.includes(this.conta.email))
        ) {
          this.component.name = "Relatorio";
        } else if (
          this.$router.history.current.path == "/validaOcr" &&
          (this.$canAccessRelatorio.includes(this.conta.email))
        ) {
          this.component.name = "ValidaOcr";
        } else if (
          this.$router.history.current.path == "/primeiroAcesso" &&
          this.conta.primAcesso
        ) {
          this.component.name = "PrimeiroAcesso";
        } else if (this.$router.history.current.path == "/fechamento") {
          this.component.name = "FechamentoMes";
        } else if (this.$router.history.current.path == "/docsFederal") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/docsMunicipal") {
          this.component.name = "ConsultaNotas";
        // } else if (this.$router.history.current.path == "/loja") {
        //   this.component.name = "Loja";
        } else {
          this.$router.push("/DashBoard");
          this.component.name = "DashBoard";
        }
      }
    });
  },
  watch: {
    "conta.getNotificacoes": function(newV, oldV) {
      if (newV) {
        this.getNotificacoes();
        this.conta.getNotificacoes = false;
      }
    },
    "IBGE.cidades.att": function(newV, oldV) {
      if (newV) {
        if (this.IBGE.cidades.uf) {
          this.getCidades(this.IBGE.cidades.uf);
          this.IBGE.cidades.att = false;
        }
      }
    },
    empresa: function() {
      // if(this.vezes === 0){
      //   this.oldId = this.empresa._id;
      //   this.getNotificacoes();
      //   this.currentProperties;
      // }
      // this.vezes++;
      // return;
    },
    $route: function() {
      if (!this.error) {
        if (this.conta.primAcesso) {
          this.$router.push("/primeiroAcesso");
        }
        this.getNotificacoes();
        if (
          this.$router.history.current.path == "/consultaCTe" ||
          this.$router.history.current.path == "/consultaNFe" ||
          this.$router.history.current.path == "/consultaNFSe"
        ) {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/ePerfil") {
          this.component.name = "editarPerfil";
        } else if (this.$router.history.current.path == "/verPerfil") {
          this.component.name = "verPerfil";
        } else if (this.$router.history.current.path == "/configuracoes") {
          this.component.name = "configuracoes";
        } else if (this.$router.history.current.path == "/configuracoesAutomacao") {
          this.component.name = "configuracoesAutomacao";
        } else if (this.$router.history.current.path == "/fornecedores") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/clientes") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/produtos") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/consultaIptu") {
          this.component.name = "ConsultaNotas";
        } else if (
          this.$router.history.current.path == "/relatorio" &&
          (this.$canAccessRelatorio.includes(this.conta.email))
        ) {
          this.component.name = "Relatorio";
        } else if (
          this.$router.history.current.path == "/validaOcr" &&
          (this.$canAccessRelatorio.includes(this.conta.email))
        ) {
          this.component.name = "ValidaOcr";
        } else if (
          this.$router.history.current.path == "/primeiroAcesso" &&
          this.conta.primAcesso
        ) {
          this.component.name = "PrimeiroAcesso";
        } else if (this.$router.history.current.path == "/fechamento") {
          this.component.name = "FechamentoMes";
        } else if (this.$router.history.current.path == "/docsFederal") {
          this.component.name = "ConsultaNotas";
        } else if (this.$router.history.current.path == "/docsMunicipal") {
          this.component.name = "ConsultaNotas";
        // } else if (this.$router.history.current.path == "/loja") {
        //   this.component.name = "Loja";
        } else {
          this.$router.push("/DashBoard");
          this.component.name = "DashBoard";
        }
      }
    }
  },
  computed: {
    getSelect: function() {},
    currentProperties: function() {
      let obj = {};
      obj["empresa"] = this.empresa;
      return obj;
    },
    getEstados: function() {
      let auxAut = Vue.http.headers.common["Authorization"];
      delete Vue.http.headers.common["Authorization"];
      this.resource = this.$resource(
        "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
      );
      this.resource.query().then(
        success => {
          this.$store.commit('addUfArray', success.body);
          this.IBGE.estados = success.body;
          this.IBGE.cidades.uf = 35;
          this.IBGE.cidades.att = true;
          return success.body;
        },
        failed => {
          this.IBGE.estados = estados;
          this.IBGE.cidades.uf = 35;
          this.IBGE.cidades.att = true;
          return estados;
        }
      );
      Vue.http.headers.common["Authorization"] = auxAut;
    }
  },
  methods: {
    openJivoChat(){
      const jivoChat = document.querySelector('jdiv');

      // Verifica se o jivochat já foi criado
      if(jivoChat) {
        jivoChat.style.display = "block";
        return;
      } else {
        // Cria o jivochat
        if (this.$router.currentRoute.path !== '/login') {
          var widget_id = 'JiAtwaHBNP';
          var d = document;
          var w = window;
          function load() {
              var s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = '//code.jivosite.com/script/widget/' + widget_id; 
              var ss = document.getElementsByTagName('script')[0]; 
              ss.parentNode.insertBefore(s, ss);
          }
          
          if (d.readyState=='complete') {
              load();
          } else { 
              if(w.attachEvent) {
                w.attachEvent('onload',load);
              } else { 
                w.addEventListener('load',load,false);
              }
          }
        }else {
          return;
        }
      } 
    },
    getCidades: function(uf) {
      if (uf) {
        let auxAut = Vue.http.headers.common["Authorization"];
        delete Vue.http.headers.common["Authorization"];
        var uf = uf;
        this.resource = this.$resource(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
        );
        this.resource.query().then(
          success => {
            this.IBGE.cidades.items = success.body;

            return success.body;
          },
          failed => {
            return [];
          }
        );
        Vue.http.headers.common["Authorization"] = auxAut;
      }
    },
    getNotificacoes: function() {
      if (this.conta && this.empresa) {
        // if(this.oldId === this.empresa._id) {
        //   return;
        // }
        // this.oldId = this.empresa._id;
        this.notifiService
          .getNotificacoesGeral(this.conta.id_usuario, this.empresa._id)
          .then(resp => {
            if (resp.status != 0) {
              if (resp.ok) {
                this.conta.notificacoes = resp.body;
              } else if (resp.status == 400) {
                this.conta.notificacoes =
                  "Notificações desativadas para esta empresa";
              } else {
                this.conta.notificacoes = undefined;
              }
            }
          });
      }
    },
    getNewEmp: async function($event) {
      //onde $event é uma empresa
      if ($event) {
        this.resource = this.$resource("empresas?cnpj=" + $event.cnpj);
        await this.resource.query().then(
          success => {
            this.empresa = success.body.items[0];
            return false;
          },
          failed => {
            if (failed.status == 404) {
              return true;
            }
          }
        );
      }
      this.attEmpresas = false;
    },
    emitAttEmpresas($event) {
      this.attEmpresas = $event;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}
#tabOption {
  font-size: 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/LoggedArea.vue